export const CHANGE_FIRE_WIDTH = 'INCREMENT_ENTHUSIASM';
